import "./admin_main.css";
import { useLocation } from "react-router-dom";
import AdminDashboardTopBar from "../admin_dashboard_nav/admin_dashboard_top_bar";
import AdminDashboardSideBar from "../admin_dashboard_nav/admin_dashboard_side_bar";
import { useState } from "react";


const AdminMain = () =>{
    const [isTopNavNavigation, setIsTopNavNavigation] = useState([true,false,false]);
    const [isSideNavNavigation, setIsSideNavNavigation] = useState([true,false,false,false,false,false]);
    const [currentAPIPageText, setCurrentAPIPageText] = useState("Overview");
    const [currentAPISubText, setCurrentAPISubText] = useState("setup");
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const [isProfileNavigation, setIsProfileNavigation] = useState([true,false,false,false]);
    const [apiKey, setApiKey] = useState(null);



    
    const location = useLocation();
    const isAdmin = location.state?.isAdmin || false;
    // Safely extract initials string
    const initials = location.state.initials;

  
    
    return(
        <div  style={{width:"100vw"}}>
            <div style={{width:"100vw"}}>
                <AdminDashboardTopBar profileModal={isProfileModalOpen} setProfileModal={setIsProfileModalOpen} initials={initials} isTopNav={isTopNavNavigation} setIsTopNav={setIsTopNavNavigation}/>
            </div>
            {isTopNavNavigation[0]&&<div className="container">
                <div className="box-left">
                    <AdminDashboardSideBar setSubText={setCurrentAPISubText} subText={currentAPISubText} setCurrentDashText={setCurrentAPIPageText} isSideNav={isSideNavNavigation} setIsSideNav={setIsSideNavNavigation} />
                </div>
            </div>}

        </div>
    );
}

export default AdminMain;